export enum RotationErrorCodes {
  AD_HAS_SEQUENCE = 'AD_HAS_SEQUENCE',
}
